import React from 'react';
import classNames from 'classnames';

import s from './loader.scss';

type LoaderItemType = {
    height?: number;
    width?: number;
    className?: string;
};

const LoaderItem: React.FC<LoaderItemType> = ({height, width, className}) => {
    return (
        <div
            className={classNames(s.item, className)}
            style={{
                height: height || 'auto',
                width: width || 'auto',
            }}
        />
    );
};

/**
 * Page wrapper
 * @return {JSX.Element} - component
 */
export const Loader: React.FC = () => {
    return (
        <div className={s.wrapper}>
            <LoaderItem height={18} width={112} className={s.mb45} />
            <LoaderItem height={22} width={81} className={s.mb17} />
            <LoaderItem height={136} />
        </div>
    );
};
